<template>
    <div class="bg-dark-create" :class="[showmodal ? 'open' : '']"></div>
    <div class="form-create-module" :class="[showmodal ? 'open' : '']" v-show={isActive}>
      <Loader :isActive="!hasReady"></Loader>
      <div class="modal" tabindex="-1">
        
        <div class="modal-dialog" >
          
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Editar atividade</h5>
            </div>
            <div class="modal-body" v-show="hasReady">
              <div class="form-group">
                <div class="form-label">
                  <label> Nome </label>
                </div>
                <div class="form-input">
                  <input
                    v-model="nameModule"
                    type="text"
                    class="form-control"
                  />
                </div>
              </div>
            </div>
            <div class="modal-body" v-show="hasReady">
              <div class="form-group">
                <label class="label-form"> Tipo </label>
                <select v-model="typefile" class="select-mode" disabled>
                  <option value="" disabled selected>Selecione o tipo</option>
                  <option value="1">Videoteca</option>
                  <option value="2">Youtube</option>
                  <option value="3">Vimeo</option>
                  <option value="4">Material PDFs</option>
                  <option value="5">Quiz</option>
                </select>
              </div>
            </div>
            <div class="modal-body" v-show="typefile == 5">
              <div class="form-group">
                <div class="form-label">
                  <label> Selecione o Quiz</label>
                </div>
                <div class="row center">
                  <div class="col-form-inner col-7 col-md-7 col-lg-7">
                    <select v-model="quiz" class="select-mode" >
                      <option value="" disabled selected>Selecione o Quiz</option>
                      <option v-for="quiz,index in listQuiz" :value="(quiz.id)" :key="index">{{ quiz.title }}</option>
                  </select>
                  </div>
                  <div class="button_quiz col-form-inner col-5 col-md-5 col-lg-5">
                    <button
                      type="button"
                      class="btn btn-warning"
                      @click="goEditQuestions()"
                      :disabled="quiz==''? true : false"
                    >
                      Questões
                    </button>
  
                    <button
                      type="button"
                      class="btn btn-primary"
                      @click="goCreateQuiz()"
                    >
                      Criar
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="modal-body"
              v-show="typefile == 2 || typefile == 3"
            >
              <div class="form-group">
                <div class="form-label">
                  <label> Link </label>
                </div>
                <div class="form-input">
                  <input
                    v-model="link_video"
                    type="text"
                    class="form-control"
                    placeholder="https://..."
                  />
                </div>
              </div>
            </div>
            <div
              class="modal-body plans"
              v-show="typefile == 1 && assinante === false && hasReady"
            >
              <div class="form-group">
                <label class="label-form"> Planos </label>
                <select class="select-mode">
                  <option value="" disabled selected>Selecione o tipo</option>
                  <option value="videoteca">1 hora</option>
                </select>
              </div>
              <div class="form-group">
                <button class="btn-add-module">Pagar</button>
              </div>
            </div>
            <div
              class="modal-body"
              v-show="typefile == 1 && assinante === true && hasReady"
            >
              <div class="form-group" v-for="index in 5 " :key="index">
                <div class="form-input">
                  <div class="input-group">
                    <div class="input-group-text">
                      <input
                        class="form-check-input mt-0"
                        type="radio"
                        value="video"
                        aria-label="Radio button for following text input"
                      />
                    </div>
                    <div class="form-label">
                      <label> Nome do Video {{ index }} </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
  
            <div class="modal-body" v-show="typefile == 4 && hasReady">
              <div class="form-group">
                <div class="form-label">
                  <label> Arquivos </label>
                </div>
                <div class="info-file">
                  Arquivo Anexado:    
                  <a :href="`https://pdf.weeduc.com/${link_video}`" target="_blank" v-if="typefile == 4"> 
                    {{ getFileName(link_video) }}
                  </a>
                </div>
               
                <div class="form-file">
                  <div class="primary">
                    <input
                      @change="handleFileChange"
                      class="form-control input-file"
                      type="file"
                      accept=".pdf"
                    />
                    <button
                      v-if="link_video"
                      @click="removeFile"
                      class="btn btn-danger"
                    >
                      Remover
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                @click="closetab()"
                class="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Cancelar
              </button>
              <button type="button" @click="saveModule()" class="btn btn-primary">
                Salvar
              </button>
            </div>
          </div>
        </div>
      </div>
      <Createquiz :idQuiz="quiz" :show="openmodalcreatequiz" @open-tab="atualizarValorNoFilho" />
      <ViewQUestions
        :idQuiz="quiz"
        :show="openmodalviewquestions"
        @open-tab="atualizarValorNoFilho2"
      />
    </div>
  </template>
  <script>
  import Createquiz from './createquiz.vue'
  import ViewQUestions from './viewquestions.vue'
  import api from '@/utils/lesson';
  import Loader from '@/components/Loader/loader.vue';
  import { mapState } from 'vuex';
  import apiQuiz from '@/utils/quiz';
  import apiLesson from '@/utils/lesson';
  import apiAWS from '@/utils/storage/aws';

  
  export default {
      data() {
          return {
              showmodal: '',
              nameModule: '',
              typefile: '',
              index: 5,
              assinante: false,
              selectedFile: null,
              link_video:'',
              openmodalviewquestions:false,
              openmodalcreatequiz:false,
              hasReady:false,
              listQuiz:null,
              quiz:null,
              isActive:false,
          }
      },
      props: {
          show: Boolean,
          data: Array,
          id: Number
      },
      components:{
          Createquiz,
          ViewQUestions,
          Loader
      },
      computed:{
        ...mapState(['token'])
      },
      methods: {
        async getDataQuiz(){
            try {
                const response = await apiQuiz.getDataQuiz(this.token);
                this.listQuiz =  response;
                this.hasReady = true;
            } catch (error) {
                console.error('Erro ao gerar listagem de quiz', error)
            }
        },
        getFileName(url) {
          const matches = url.match(/[^/]+$/);
          return matches ? matches[0] : '';
        },
          closetab() {
            this.showmodal = false;
            this.hasReady = false
            this.$emit('open-tab', this.showmodal)
          },
          opentab() {
              this.show = true,
              this.$emit('open-tab', this.showmodal)
          },
          saveModule() {
            this.hasReady = false

            const id = this.data.id;
            const idModule = this.data.moduleId;
            const obj = {
                "module": {
                    "id": idModule
                },
                "type": this.typefile ? this.typefile : this.data.type,
                "title": this.nameModule,
                "status": 1,
                // "order": this.lastOrder+1,
            };
            if (this.link_video) {
                obj.path = this.link_video; 
            }
            if (this.quiz) {
                obj.quiz = {
                    "id": this.quiz
                };
            }
            try {
                const response = apiLesson.editLesson(this.token, obj, id);
                console.debug(response);
            } catch (error) {
              console.error(error)
            }
            this.hasReady = false;
            setTimeout(() => {
                this.showmodal = false;
                this.$emit('open-tab', this.showmodal)
              }, 1000);
          },
          removeFile() {
              this.selectedFile = null;
          },
          // handleFileChange(event) {
          //     this.selectedFile = event.target.files[0];
          // },
          goCreateQuiz(){
             this.openmodalcreatequiz = !this.openmodalcreatequiz;
          },
          goEditQuestions(){
              this.openmodalviewquestions = !this.openmodalviewquestions;
          },
          atualizarValorNoFilho(novoValor) {
              this.openmodalcreatequiz = novoValor;
          },
          atualizarValorNoFilho2(novoValor2) {
              this.openmodalviewquestions = novoValor2;
          },
          async getDataLesson(){
            if(this.data.id){
                try {
                const response = await api.getDataLessonById(this.data.id, this.token);
                this.nameModule = response.title;
                this.typefile = response.type;
                this.hasReady = true;
                this.link_video = response.path;
                this.quiz = response.quiz.id;
                if(response.type == 5){
                  this.getDataQuiz();
                }
              } catch (error) {
                console.error('Erro ao carregar lesson', error)
              }
            }
          
          },
          async putFileAws(url, file){
          try {
              const response = await apiAWS.putFileAWS(url, file);
          } catch (error) {
              console.error('Erro ao enviar arquivo para AWS');
          }
        },
        async handleFileChange(event){
            const file = event.target.files[0];

            try {
                const response =  await apiAWS.getSignaturePdf(this.token, file.name);
                this.putFileAws(response.url, file)
                this.link_video = response.token;
                console.debug(response);
            } catch (error) {
                console.error('Erro na geração do TOKEN AWS')
            }
        },
      },
      created(){
        this.getDataLesson();
        
        
      },
      watch: {
          show(novoValor) {
              this.getDataLesson()
              this.showmodal = this.show;
          },
          openmodalcreatequiz(newvalue){
              this.hasReady = false;
              setTimeout(() => {
                  this.getDataQuiz();
                  console.debug(`OpenModalCreateQuiz Alterado`, this.openmodalcreatequiz);
              }, 1000);
          },  
         
      }
  };
  </script>
  
  <style>
  @import "./tabs.css";
  .row.center {
    align-items: center;
}
.row.center button{
  height: 45px;
}
.dashboard.dark .info-file {
  color: white;
}
.dashboard.dark .info-file a {
  color: white;
}
.dashboard.dark input.form-control.input-file {
  background-color: gray;
}

  </style>
  